import { render, staticRenderFns } from "./ListaSegmentos.vue?vue&type=template&id=b31aee38&scoped=true"
import script from "./ListaSegmentos.vue?vue&type=script&lang=js"
export * from "./ListaSegmentos.vue?vue&type=script&lang=js"
import style0 from "./ListaSegmentos.vue?vue&type=style&index=0&id=b31aee38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31aee38",
  null
  
)

export default component.exports